var _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.00118 9.62659L9.62868 9.62697C11.4927 9.62697 13.0037 11.138 13.0037 13.002L7.75291 13.0013L7.75366 13.752L13.7537 13.7514V13.002C13.7537 12.1901 13.515 11.4246 13.0891 10.7514L15.2537 10.752C16.7479 10.752 18.038 11.6259 18.6408 12.8905C16.8672 15.231 13.9951 16.752 10.7537 16.752C8.6827 16.752 6.92828 16.309 5.50335 15.5334L5.50444 8.55522C6.4386 8.68902 7.29342 9.06867 8.00118 9.62659ZM4.00366 7.75195C4.38829 7.75195 4.70529 8.04148 4.74862 8.41449L4.75366 8.50129V15.252C4.75366 15.6662 4.41788 16.002 4.00366 16.002H2.50366C2.08945 16.002 1.75366 15.6662 1.75366 15.252V8.50197C1.75366 8.08774 2.08945 7.75195 2.50366 7.75195H4.00366Z",
    fill: "url(#paint0_linear_18417_5661)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6.5,
    r: 2.5,
    fill: "#7A67FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18417_5661",
    x1: 1.75366,
    y1: 12.252,
    x2: 18.6408,
    y2: 12.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon16);
export default __webpack_public_path__ + "static/media/navicon16.11fc64543d3c46788e698a689ab2942b.svg";
export { ForwardRef as ReactComponent };